/**
 * @deprecated
 * This array is hard-coded for Table ID 1 only and doesn't work with new data formats
 */
export const titles = [
	"DateTime(UTC)",
	"Battery Voltage(V)",
	"Minimum Panel Temperature(°C)",
	"Hourly avg Air Temperature (°C)",
	"Relative Humidity (%)",
	"Shortwave Radiation (W/m²)",
	"Barometric Pressure (hPa)",
	"Hourly avg Wind Speed(m/s)",
	"Avg & Variation Wind Direction (°±1sd)",
];

export const config = { responsive: true, showSendToCloud: false };

export const layout = {};
interface TableMetadata {
	numDomains: number;
	numFields: number;
	description: string;
}

export const tableMetadata: Record<number, TableMetadata> = {
	1: {
		numDomains: 4,
		numFields: 9, // 8 data fields + timestamp
		description: "Hourly telemetry - legacy",
	},
	2: {
		numDomains: 5,
		numFields: 23, // 22 data fields + timestamp (reduced from 32)
		description: "Mt. Fleming - with radiation data",
	},
	3: {
		numDomains: 5,
		numFields: 19, // 18 data fields + timestamp (reduced from 28)
		description: "Standard 2025",
	},
	4: {
		numDomains: 7,
		numFields: 15, // 14 data fields + timestamp
		description: "Cass Sugar Loaf Summit DAT",
	},
};
